import { NgModule } from '@angular/core';

import { ContactInfoCardComponent } from './contact-info-card/contact-info-card.component';
export { ContactInfoCardComponent };

import { ContactInfoOnHoverDirective } from './contact-info-on-hover/contact-info-on-hover.directive';
export { ContactInfoOnHoverDirective };

import { CardDataType } from './contact-info-types';
export { CardDataType };

@NgModule({
  imports: [ContactInfoCardComponent, ContactInfoOnHoverDirective],
  exports: [ContactInfoCardComponent, ContactInfoOnHoverDirective],
})
export class GalaxyContactInfoCardModule {}
